
export function repeat(count = 25, value = {}) {
    let result = [];
    for (let idx = 0; idx < count; idx++) {
        if (typeof value === 'function') {
            result.push(value());
        } else {
            result.push(value);
        }
    }
    return result;
}

export function pagedQuery(query) {
    return (root, vars) => {
        let {offset, limit} = vars;
        if (offset == null) offset = 0;
        if (limit == null) limit = 25;
        const values = query(root, vars);
        return {
            limit,
            offset,
            totalCount: values.length,
            hasMoreData: offset + limit < values.length,
            results: values.slice(offset, offset + limit),
        };
    };
}


export function mockPagedQuery(count = 75, value = {}) {
    return (root, vars) => {
        let {offset, limit} = vars;
        if (offset == null) offset = 0;
        if (limit == null) limit = 25;
        return {
            limit,
            offset,
            totalCount: count,
            hasMoreData: offset + limit < count,
            results: repeat(Math.min(limit, count - offset), value),
        };
    };
}
